import format from 'date-fns/format';
import { DateTime } from 'luxon';
import { useTranslation } from 'next-i18next';

import { useCountdown } from '../../../../hooks/useCountdown';
import { isInNext24Hours, isInNextSixDays } from '../../../../utils/product';

type Props = {
  expiresAt: Date;
};

export const RoomDateCountdown = ({ expiresAt }: Props) => {
  const { t } = useTranslation('private');
  const { destructuredDate } = useCountdown({
    addDaysToHours: false,
    date: expiresAt,
  });

  const isExpired = expiresAt < new Date();
  const timeZone = DateTime.local().offsetNameShort;

  if (isExpired) {
    return t('unlock.countdown.dateExpired', {
      date: `${format(expiresAt, 'dd MMM, HH:mm')} ${timeZone}`,
    });
  }

  let date = t('unlock.countdown.date', {
    date: `${format(expiresAt, 'dd MMM, HH:mm')} ${timeZone}`,
  });

  const showCountdown = isInNextSixDays(expiresAt);
  if (showCountdown) {
    date = isInNext24Hours(expiresAt)
      ? t('unlock.countdown.time', destructuredDate)
      : t('unlock.countdown.days', destructuredDate);
  }

  return <>{date}</>;
};
